// extracted by mini-css-extract-plugin
module.exports = {"row":"SectionRow_row__Ylx7D"};